<template>
  <div class="iot-widget-wrapper">
    <h5 class="title is-4 is-flex align-center has-text-weight-light">
      <icon class="mr has-text-grey" icon="fire"/>
      <span>24 V DC PSU</span>
    </h5>

    <div class="columns">
      <div class="column">
        <span class="is-flex align-center" v-if="isOn">
          <icon class="has-text-success iginition-status-icon" icon="check-circle"/>
          <span class="has-text-weight-bold">
            The 24 V DC PSU is currently ON.
            <br>
            <span
              :data-tooltip="`The 24 V DC PSU is ON as at the latest reading, at ${latestReading.read_at}`"
              class="is-size-7 has-text-grey tooltip"
            >{{ latestReading.read_at | date('L LTS') }}</span>
          </span>
        </span>
        <span class="is-flex align-center" v-if="isOff">
          <icon class="has-text-danger iginition-status-icon" icon="circle"/>
          <span class="has-text-weight-bold">
            The 24 V DC PSU is currently OFF.
            <br>
            <span
              :data-tooltip="`The 24 V DC PSU is OFF as at the latest reading, at ${latestReading.read_at}`"
              class="is-size-7 has-text-grey tooltip"
            >{{ latestReading.read_at | date('L LTS') }}</span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    latestReading: {
      type: Object,
      required: true,
    },
    oldestReading: {
      type: Object,
      required: true,
    },
    last24HourReadings: {
      type: Array,
      default: [],
      required: true,
    },
    variableName: {
      type: String,
      required: true,
    },
  },

  computed: {
    isOn() {
      return this.latestReading.data[this.variableName]
    },
    isOff() {
      return !this.isOn
    },
  },
}
</script>